// GAVION pw-reset-delegated: Paramètres → Intégrations → « Expéditeur des courriels système » (admins).
export const systemSenderFr = {
  title: "Expéditeur des courriels système",
  description:
    "La boîte noreply envoie les courriels « Mot de passe oublié ? ». Un administrateur la connecte une seule fois, en se connectant à Microsoft avec le compte noreply (pas le sien).",
  status: {
    none: "Non connecté",
    disconnected: "Non connecté",
    connected: "Connecté",
    needs_reauth: "À reconnecter",
  },
  connect: "Connecter l'expéditeur noreply",
  reconnect: "Reconnecter l'expéditeur noreply",
  disconnect: "Déconnecter",
  sign_in_as:
    "Dans la fenêtre Microsoft, connectez-vous avec %{address} (choisissez « Utiliser un autre compte » au besoin).",
  connected_as: "Connecté : %{email}",
  last_refresh: "Dernier renouvellement du jeton : %{at}",
  never_refreshed: "Jeton pas encore renouvelé",
  not_configured:
    "L'adresse d'envoi (PASSWORD_RESET_FROM) n'est pas réglée : voir la procédure « Réinitialisation du mot de passe ».",
  mismatch:
    "La boîte connectée n'est pas %{address} : reconnectez l'expéditeur avec ce compte. Aucun courriel ne part en attendant.",
  needs_reauth_help:
    "Microsoft a refusé le jeton : les courriels « Mot de passe oublié ? » ne partent plus. Reconnectez l'expéditeur noreply.",
  connected_toast: "Expéditeur noreply connecté.",
  disconnected_toast: "Expéditeur noreply déconnecté.",
  confirm_disconnect_title: "Déconnecter l'expéditeur noreply ?",
  confirm_disconnect_body:
    "Les courriels « Mot de passe oublié ? » ne partiront plus jusqu'à la prochaine connexion. Les administrateurs peuvent toujours donner un « Lien de mot de passe ».",
  errors: {
    system_sender_mismatch:
      "Ce compte Microsoft n'est pas la boîte d'envoi prévue. Reconnectez-vous avec le compte noreply.",
    system_sender_not_configured:
      "L'adresse d'envoi (PASSWORD_RESET_FROM) n'est pas réglée.",
    forbidden: "Réservé aux administrateurs.",
  },
};
